import script from "./ranking-table.vue?vue&type=script&lang=ts&setup=true"
export * from "./ranking-table.vue?vue&type=script&lang=ts&setup=true"

import "./ranking-table.vue?vue&type=style&index=0&id=3b051eac&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b051eac"]])

export default __exports__